import { render, staticRenderFns } from "./ListEvaluationsReception.vue?vue&type=template&id=1dc040f6&"
import script from "./ListEvaluationsReception.vue?vue&type=script&lang=js&"
export * from "./ListEvaluationsReception.vue?vue&type=script&lang=js&"
import style0 from "./ListEvaluationsReception.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports